module.exports = __webpack_public_path__ + "img/4.c2cb82f2.png";